import styled from 'styled-components';
import theme from "../theme";

export const P = styled.p`
  font-size: ${theme.typography.body.fontSize};
  line-height: ${theme.typography.body.lineHeight};
  ${({margin}) => margin && { margin }};
`
